import React from "react";
import { FormattedMessage } from "react-intl";
import HeroImage from "images/goopter-dashboard.png";
import { Link } from "react-router-dom";
import Button from "components/Button";

export default function Hero() {
  return (
    <section className="hero-section">
      <div className="row mx-auto">
        <div className="col-lg-5 col-sm-12">
          <div className="text-container">
            <div className="table-cell">
              <h5 className="accent sub-title">
                <FormattedMessage id="hero_subtitle" />
              </h5>
              <h2>
                <FormattedMessage id="hero_title" />
              </h2>
              <p>
                <FormattedMessage id="hero_desc" />
              </p>
              <div className="links d-flex">
              <Button text={<FormattedMessage id="request_a_demo" />}
                link={"/request-a-demo"}
              />
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-7 col-sm-12 image-container">
          <img src={HeroImage} alt="goopter" />
        </div>
      </div>
    </section>
  );
}
